import React, { useRef, useEffect, useCallback } from 'react'
import styles from './Intro.module.scss'
import gsap from 'gsap';
import logo from '../../assets/logo.svg';

const Intro = ({ children }) => {

    const circle1 = useRef(null);
    const circle2 = useRef(null);
    const rect = useRef(null);
    const sv = useRef(null);

    const curve = "M0 502S175 272 500 272s500 230 500 230V0H0Z";
    const flat = "M0 2S175 1 500 1s500 1 500 1V0H0Z";

    const animateIntro = useCallback(() => {
        const tl = gsap.timeline();
        tl.from(circle1.current, { delay: 1, y: 300, skewY: 5 })
            .to(circle1.current, { delay: 1, y: -600, skewY: 5 })
        tl.to(sv.current, { duration: 0.8, attr: { d: curve }, ease: "power2.easeIn" })
            .to(sv.current, { duration: 0.8, attr: { d: flat }, ease: "power2.easeOut" })
        tl.to(circle2.current, { y: -1500 })
        tl.to(circle2.current, { zIndex: -1, display: 'none' })
        tl.from(rect.current, { opacity: 0 }, "-=1.5")
    }, [curve, flat])

    useEffect(() => {
        animateIntro()
    }, [animateIntro])

    const Logo = () => {
        return (
            <div className={styles.logoContainer}>
                <img src={logo} alt="SH Logo" className={styles.logoImage} />
            </div>
        )
    }

    return (
        <div className={styles.Intro}>

            <div ref={circle2} className={styles.loader_wrap}>
                <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
                    <path ref={sv} id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"></path>
                </svg>
                <div className={styles.loader_wrap_heading}><div className={styles.wrapper}><h1 ref={circle1} ><Logo /></h1></div></div>
            </div>

            <div>
                <div className={styles.wrapper} ref={rect}>{children}</div>
            </div>

        </div>

    )
}

export default Intro